const React = window.React || null;
const { useState, useEffect } = React;
const ReactDOM = window.ReactDOM || null;
import Search from './components/Search';
import LogoAdw from './components/LogoAdw';
import MainMenu from './components/MainMenu';
import ThemeSwitcher from './components/ThemeSwitcher';
import UserNav from './components/UserNav';


function App() : React.ReactElement {

    // Insert App into the DOM immediately before end of body using react portal
    // ReactDOM.createPortal(<App />,

    return (
        <>
        <div>

            {ReactDOM.createPortal(<NavModal />, document.body)}

        </div>
        </>
    )
};

export { App };

function NavModal({show = false}: {show?: boolean}): React.ReactElement {

    const [toggleVisibility, setToggleVisibility] = useState(show || false);
    const refNavModal = React.useRef<HTMLDivElement>(null);

    // Toggle visibility of modal menu
    useEffect(() => {
        const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');
        elHamburgerIcon?.addEventListener('click', () => {
            setToggleVisibility( true );
        });

        // Close modal when esc key is pressed
        const handleKeyDownClose = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                setToggleVisibility( false );
            }
        }
        document.addEventListener('keydown', handleKeyDownClose, {
            passive: true
        });

        return () => {
            // Clean up event listeners
            elHamburgerIcon?.removeEventListener('click', () => {
                setToggleVisibility( true );
            });
            document.removeEventListener('keydown', handleKeyDownClose);
        }
    }, []);

    const handleBodyScroll = ( toggleVisibility : Boolean ) => {
        if( toggleVisibility === true ){
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = 'auto';
        }
    }

    // Open modal if `/` is pressed
    useEffect(() => {

        // If modal is already open, do not add event listener
        if( toggleVisibility ) return;

        const elHamburgerIcon = document.getElementById('aw-nav-menu-icon');
        // Open modal when `/` key is pressed
        const handleKeyDownOpen = (event: KeyboardEvent) => {
            if (event.key === '/') {
                if( toggleVisibility === false ){
                    event.stopPropagation();
                    event.preventDefault();
                    elHamburgerIcon?.click();
                    const elSearch : HTMLInputElement | null = document.querySelector('.adw-search');
                    if( elSearch ){
                        elSearch.value = '';
                    }
                }
            }
        }
        document.addEventListener('keydown', handleKeyDownOpen);

        return () => {
            // Clean up event listeners

            document.removeEventListener('keydown', handleKeyDownOpen);
        }
    }, [toggleVisibility]);

    // Handle body scroll

    useEffect(() => {
        handleBodyScroll( toggleVisibility );
    }, [toggleVisibility]);

    return (
        <>
        { toggleVisibility &&
            <div
                className="bg-light-subtle z-3 w-100 d-flex flex-column
                    position-fixed top-0 bottom-0 left-0 right-0 overflow-auto
                    "
                
                style={{ backgroundColor: "var(--bs-body-bg)", color: "var(--bs-body-color)" }}
                ref={refNavModal}
                id="nav-modal"
            >

                <div className="container-xxl pb-5 px-4 px-xxl-0 d-flex h-100 flex-column gap-2 gap-lg-4 ">
                    {/* Close Icon */}
                    <div
                        className="d-flex w-100 py-3 py-lg-5 ps-0 pe-4 px-sm-4 px-xxl-0 justify-content-between align-items-center"
                        
                    >
                        
                        {/* Logo */}
                        <LogoAdw />

                        <div className="d-flex align-items-center gap-3">
                            
                            <UserNavPortal className="d-none d-lg-flex" />

                            <div className="">
                                <ThemeSwitcher />
                            </div>

                            <button onClick={() => setToggleVisibility( !toggleVisibility )}
                                className="btn-link border-0 align-self-center p-0"
                            >
                                <CloseIcon  />
                            </button>

                        </div>
                    </div>

                    <div className="flex-grow-1 d-flex flex-column gap-4 gap-lg-5 mt-lg-4 pb-5 border-bottom border-primary">

                        {/* For Mobile */}
                        <UserNavPortal className="d-flex d-lg-none justify-content-end justify-content-lg-start mb-4" />

                        <Search onClose={() => setToggleVisibility(false)}/>

                        {/* Main Menu */}
                        <MainMenu />


                    </div>
                    {/* Footer Menu cloned from page */}
                    <FooterMenu />
                </div>

            </div>
        }
        </>
    )
}

const CloseIcon = ( props : any ): React.ReactElement => {
    return (
        <svg {...props} width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M24.6929 6.29289C25.0834 5.90237 25.7166 5.90237 26.1071 6.29289C26.4977 6.68342 26.4977 7.31658 26.1071 7.70711L17.8142 16L26.1071 24.2929C26.4977 24.6834 26.4977 25.3166 26.1071 25.7071C25.7166 26.0976 25.0834 26.0976 24.6929 25.7071L16.4 17.4142L8.10713 25.7071C7.71661 26.0976 7.08344 26.0976 6.69292 25.7071C6.30239 25.3166 6.30239 24.6834 6.69292 24.2929L14.9858 16L6.69292 7.70711C6.30239 7.31658 6.30239 6.68342 6.69292 6.29289C7.08344 5.90237 7.71661 5.90237 8.10713 6.29289L16.4 14.5858L24.6929 6.29289Z" fill="currentColor" />
        </svg>
    );
}

const UserNavPortal = ({className = ''}: {className?: string}): React.ReactElement => {
    const ref = React.useRef<HTMLDivElement>(null);
    const [portalNode, setPortalNode] = useState<HTMLDivElement | null>(null);
    const [innerHtml, setInnerHtml] = useState('');

    useEffect(() => {
        setPortalNode(ref.current);
        const elUserNav = document.querySelector('.user-nav');
        setInnerHtml(elUserNav?.innerHTML || '');
    }, []);

    return (
        <div className={className} ref={ref}>
            { portalNode && ReactDOM.createPortal(
                <UserNav innerHtml={innerHtml} />,
                portalNode
            ) }
        </div>
    );
}

const FooterMenu = () => {
    const footerHtmlMarkup = document.querySelector('.footer-nav')?.outerHTML || '';

    return (
        <div
            className="footer-nav-in-modal mb-5 mx-n4 "
            dangerouslySetInnerHTML={{__html: footerHtmlMarkup}}
        >
            {/* Dynamic HTML from DOM */}
        </div>
    )
}